'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const skeleton = require('../Skeleton/skeleton.js');

var heightByRatio = function heightByRatio(_ref) {
  var width = _ref.width,
    ratio = _ref.ratio;
  return "calc(".concat(ratio / 100, " * ").concat(width, ")");
};
var HeadshotSkeleton = styled__default(skeleton).withConfig({
  displayName: "headshotstyle__HeadshotSkeleton",
  componentId: "sc-1i49e69-0"
})(["height:", ";"], heightByRatio);

exports.HeadshotSkeleton = HeadshotSkeleton;
